import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, FormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from 'src/app/_services/project.service';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { SettingService } from 'src/app/_services/setting.service';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';

@Component({
  selector: 'app-aws-setting',
  templateUrl: './aws-setting.component.html',
  styleUrls: ['./aws-setting.component.scss']
})
export class AwsSettingComponent implements OnInit {
  projectId: string;
  projectData: any;
  awsSettingData: any;
  feildName: any;
  awsFeildValue: any;
  formObj: any;
  submitted: boolean;
  headerOptions = {
    showSetting : false,
    showSearch: false,
    heading : 'Settings',
    data: undefined,
  }
  currentUrl: any;
  previousUrl: any=[];
  previousUrltemp: any;
  agentCheck: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private project: ProjectService,
    private toastrService: ToastrService,
    private confirmationDialogService: ConfirmationDialogService,
    private setting: SettingService,
    private router:Router,
    private urlService:UrlService,
    private memoryService: MemoryService,
    private homeService: HomeService,
    @Inject(DOCUMENT) private document: Document,
  ) { }
  @ViewChild('cancelmodal', null) cancelmodal: ElementRef;
  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.project.getProjectById(this.projectId).subscribe((
          data => {
            this.projectData = data;
            this.headerOptions.data = {
              projectId: this.projectId,
              projectName: data['projectName']
            };
            //set header details
            this.homeService.setHeaderOptions(this.headerOptions);
            this.getAwsSettingData(this.projectId);
            //console.log(this.projectData);

          }
        ))

      }
    )
    if(this.agentCheck)
    {
      this.memoryService.getUrlHistory().subscribe((res)=>
      {
        this.previousUrl =  res;
        if(this.previousUrl.length > 0)
        {
          this.currentUrl =  this.router.url;
          this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else
    {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if(!this.previousUrl){
        this.currentUrl =  this.router.url;
        this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }
  }
  geturlName(url) {
    return this.urlService.geturlName(url);
  }
  getAwsSettingData(projectId) {
    this.setting.getAwsSetting(projectId).subscribe(
      (data) => {
        this.awsSettingData = data;
        //console.log('>>>>>', data);
      }
    )
  }

  filterBugLog(name, value) {
    this.feildName = name;
    this.awsFeildValue = value;
    //console.log(this.feildName, this.awsFeildValue);

  }

  onSubmit(editProjectSettingForm) {
    this.formObj = editProjectSettingForm.value;
    const awsValue = Object.values(this.formObj)[0];
    const key = Object.getOwnPropertyNames(this.formObj)[0];

    //console.log(awsValue);
    //console.log(key);
    this.submitted = true;
    //console.log(this.formObj);
    var objectForUpdate = {
      key: key,
      prjId: this.projectId,
      value: awsValue
    }
    // if (objectForUpdate['value'] == '' || objectForUpdate['value'] == undefined ) {
    //   this.toastrService.clear();
    //   this.toastrService.warning('Can not add empty value');
    //   return;
    // }
    this.setting.updateAwsSetting(this.projectId, key, awsValue, objectForUpdate).subscribe(
      (data) => {
        this.getAwsSettingData(this.projectId);
        this.cancelmodal.nativeElement.click();
        this.toastrService.clear();
        this.toastrService.success('Automation setting updated successfully');
      }
    )
  }
}